export default __webpack_public_path__ + "static/media/gmail-red.ddb4582f.svg";